var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"container",staticClass:"marquee",class:{
    reset: _vm.reset,
    visible: _vm.repeat !== 0
  }},[_c('span',{ref:"text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_vm._l((_vm.repeat),function(i){return _c('span',{key:i},[_vm._v(_vm._s(_vm.text))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }